{
  "INTEGRATION_SETTINGS": {
    "SHOPIFY": {
      "DELETE": {
        "TITLE": "Delete Shopify Integration",
        "MESSAGE": "Are you sure you want to delete the Shopify integration?"
      },
      "STORE_URL": {
        "TITLE": "Connect Shopify Store",
        "LABEL": "Store URL",
        "PLACEHOLDER": "your-store.myshopify.com",
        "HELP": "Enter your Shopify store's myshopify.com URL",
        "CANCEL": "Atcelt",
        "SUBMIT": "Connect Store"
      },
      "ERROR": "There was an error connecting to Shopify. Please try again or contact support if the issue persists."
    },
    "HEADER": "Integrācijas",
    "DESCRIPTION": "Kontaktu centrs integrējas ar vairākiem rīkiem un pakalpojumiem, lai uzlabotu jūsu komandas efektivitāti. Izpētiet tālāk esošo sarakstu, lai konfigurētu savas iecienītākās lietotnes.",
    "LEARN_MORE": "Uzzināt vairāk par integrācijām",
    "LOADING": "Integrāciju iegūšana",
    "CAPTAIN": {
      "DISABLED": "Captain jūsu kontā nav iespējots.",
      "CLICK_HERE_TO_CONFIGURE": "Noklikšķiniet šeit, lai konfigurētu",
      "LOADING_CONSOLE": "Notiek Captain konsoles ielāde...",
      "FAILED_TO_LOAD_CONSOLE": "Neizdevās ielādēt Captain konsoli. Lūdzu, mēģiniet vēlreiz."
    },
    "WEBHOOK": {
      "SUBSCRIBED_EVENTS": "Abonētie Notikumi",
      "LEARN_MORE": "Uzzināt vairāk par webhooks",
      "FORM": {
        "CANCEL": "Atcelt",
        "DESC": "Webhook notikumi sniedz Jums reāllaika informāciju par to, kas notiek jūsu kontā. Lūdzu, ievadiet derīgu URL, lai nokonfigurētu atzvanīšanu.",
        "SUBSCRIPTIONS": {
          "LABEL": "Notikumi",
          "EVENTS": {
            "INBOX_CREATED": "Iesūtne izveidota",
            "CONVERSATION_CREATED": "Saruna izveidota",
            "CONVERSATION_STATUS_CHANGED": "Sarunas Statuss Mainīts",
            "CONVERSATION_UPDATED": "Saruna Atjaunināta",
            "MESSAGE_CREATED": "Ziņojums izveidots",
            "MESSAGE_UPDATED": "Ziņojums atjaunināts",
            "WEBWIDGET_TRIGGERED": "Lietotājs atvēra tiešsaistes tērzēšanas logrīku",
            "CONTACT_CREATED": "Kontaktpersona izveidota",
            "CONTACT_UPDATED": "Kontaktpersona atjaunināta",
            "JARABOT_EVENT": "Iekšējie notikumi"
          }
        },
        "END_POINT": {
          "LABEL": "Webhook URL",
          "PLACEHOLDER": "Piemēram: {webhookExampleURL}",
          "ERROR": "Lūdzu, ievadiet derīgu URL"
        },
        "EDIT_SUBMIT": "Atjaunināt webhook",
        "ADD_SUBMIT": "Izveidot webhook"
      },
      "TITLE": "Webhook",
      "CONFIGURE": "Konfigurēt",
      "HEADER": "Webhook iestatījumi",
      "HEADER_BTN_TXT": "Pievienot jaunu webhook",
      "LOADING": "Notiek pievienoto webhook iegūšana",
      "SEARCH_404": "Šim vaicājumam nav atbilstošu vienumu",
      "SIDEBAR_TXT": "<p><b>Webhook</b> </p> <p>Webhook ir HTTP atzvani, kurus var definēt katram kontam. Tos aktivizē tādi notikumi kā ziņojumu izveide. Šim kontam varat izveidot vairāk nekā vienu webhook. <br /><br /> Lai izveidotu <b>webhook</b>, noklikšķiniet uz <b>Pievienot jaunu webhook</b> pogas. Jūs varat arī noņemt jebkuru esošo webhook, noklikšķinot uz pogas Dzēst.</p>",
      "LIST": {
        "404": "Šim kontam nav nokonfigurēts neviens webhook.",
        "TITLE": "Pārvaldīt webhook",
        "TABLE_HEADER": {
          "WEBHOOK_ENDPOINT": "Webhook galapunkts",
          "ACTIONS": "Darbības"
        }
      },
      "EDIT": {
        "BUTTON_TEXT": "Rediģēt",
        "TITLE": "Rediģēt webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfigurācija ir veiksmīgi atjaunināta",
          "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
        }
      },
      "ADD": {
        "CANCEL": "Atcelt",
        "TITLE": "Pievienot jaunu webhook",
        "API": {
          "SUCCESS_MESSAGE": "Webhook konfigurācija ir veiksmīgi pievienota",
          "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
        }
      },
      "DELETE": {
        "BUTTON_TEXT": "Dzēst",
        "API": {
          "SUCCESS_MESSAGE": "Webhook ir veiksmīgi izdzēsts",
          "ERROR_MESSAGE": "Nevar izveidot savienojumu ar Woot serveri. Lūdzu, vēlāk pamēģiniet vēlreiz"
        },
        "CONFIRM": {
          "TITLE": "Apstiprināt Dzēšanu",
          "MESSAGE": "Vai tiešām vēlaties izdzēst webhook? ({webhookURL})",
          "YES": "Jā, Dzēst ",
          "NO": "Nē, Paturēt"
        }
      },
      "DISABLED_BADGE": "Atspējots",
      "DISABLED_REASON": "Automātiski atspējots pēc {count} secīgām kļūdām. Pēdējā kļūda: {error}",
      "ENABLE": {
        "BUTTON_TEXT": "Iespējot",
        "API": {
          "SUCCESS_MESSAGE": "Webhook veiksmīgi iespējots",
          "ERROR_MESSAGE": "Neizdevās iespējot webhook, lūdzu, vēlāk mēģiniet vēlreiz"
        }
      }
    },
    "SLACK": {
      "DELETE": "Dzēst",
      "DELETE_CONFIRMATION": {
        "TITLE": "Dzēst integrāciju",
        "MESSAGE": "Vai tiešām vēlaties dzēst integrāciju? To darot, tiks zaudēta piekļuve sarunām Jūsu Slack workspace."
      },
      "HELP_TEXT": {
        "TITLE": "Kā izmantot Slack integrāciju?",
        "BODY": "Izmantojot šo integrāciju, visas jūsu ienākošās sarunas tiks sinhronizētas ar kanālu ***{selectedChannelName}*** jūsu Slack darbvietā. Jūs varat pārvaldīt visas savas klientu sarunas tieši kanālā un nekad nepalaist garām nevienu ziņojumu.\n\nŠādas ir galvenās integrācijas īpašības:\n\n**Atbldēt uz sarunām no Slack:** Lai atbildētu uz sarunu ***{selectedChannelName}*** Slack kanālā, uzrakstiet savu ziņojumu un nosūtiet to kā pavedienu. Šādi tiks izveidota atbilde klientam, izmantojot Kontaktu centru.\n\n**Izveidot privātas piezīmes:** ja vēlaties izveidot privātas piezīmes, nevis atbildes, sāciet ziņojumu ar ***`note:`***. Tas nodrošina, ka jūsu ziņojums ir privāts un nebūs redzams klientam.\n\n**Saistīt aģenta profilu:** ja personai, kas atbildēja Slack, ir aģenta profils Kontaktu centrā ar to pašu e-pasta adresi, atbildes tiks automātiski saistītas ar šo aģenta profilu. Tas nozīmē, ka varat viegli izsekot kurš ko teica un kad. No otras puses, ja atbildētājam nav saistīta aģenta profila, atbildes klientam tiks rādītas no robotprogrammatūras profila.",
        "SELECTED": "izvēlēts"
      },
      "SELECT_CHANNEL": {
        "OPTION_LABEL": "Izvēlēties kanālu",
        "UPDATE": "Atjaunināt",
        "BUTTON_TEXT": "Pievienot kanālu",
        "DESCRIPTION": "Jūsu Slack workspace tagad ir saistīta ar Kontaktu centru, taču integrācija pašlaik ir neaktīva. Lai aktivizētu integrāciju un savienotu kanālu, lūdzu, noklikšķiniet uz tālāk esošās pogas.\n\n**Piezīme:** Ja mēģinat izveidot savienojumu ar privātu kanālu, pirms turpināt šo darbību, pievienojiet mūsu lietotni Slack kanālam.",
        "ATTENTION_REQUIRED": "Nepieciešama uzmanība",
        "EXPIRED": "Jūsu Slack integrācijas derīguma termiņš ir beidzies. Lai turpinātu saņemt ziņojumus pakalpojumā Slack, lūdzu, izdzēsiet integrāciju un vēlreiz pievienojiet savu workspace."
      },
      "UPDATE_ERROR": "Atjauninot integrāciju radās kļūda. Lūdzu, mēģiniet vēlreiz",
      "UPDATE_SUCCESS": "Kanāls ir veiksmīgi pievienots",
      "FAILED_TO_FETCH_CHANNELS": "Ienesot kanālus no Slack radās kļūda. Lūdzu, mēģiniet vēlreiz"
    },
    "OPEN_AI": {
      "AI_ASSIST": "AI Palīgs",
      "WITH_AI": " {option} ar AI ",
      "OPTIONS": {
        "REPLY_SUGGESTION": "Atbildes Ieteikums",
        "SUMMARIZE": "Apkopot",
        "REPHRASE": "Uzlabot Rakstību",
        "FIX_SPELLING_GRAMMAR": "Izlabot Pareizrakstību un Gramatiku",
        "SHORTEN": "Saīsināt",
        "EXPAND": "Izvērst",
        "MAKE_FRIENDLY": "Mainīt ziņojuma toni uz draudzīgu",
        "MAKE_FORMAL": "Izmantot formālu toni",
        "SIMPLIFY": "Vienkāršot",
        "TRANSLATE": "Tulkot",
        "TRANSLATE_TO_MAJORITY_LANGUAGE": "Tulkot vairākuma valodā"
      },
      "ASSISTANCE_MODAL": {
        "DRAFT_TITLE": "Melnraksta saturs",
        "GENERATED_TITLE": "Ģenerētais saturs",
        "AI_WRITING": "AI raksta",
        "BUTTONS": {
          "APPLY": "Izmantot šo ieteikumu",
          "CANCEL": "Atcelt"
        }
      },
      "CTA_MODAL": {
        "TITLE": "Integrēt ar OpenAI",
        "DESC": "Ievietot uzlabotās AI funkcijas savā informācijas panelī, izmantojot OpenAI GPT modeļus. Lai sāktu, ievadiet sava OpenAI konta API atslēgu.",
        "KEY_PLACEHOLDER": "Ievadiet savu OpenAI API atslēgu",
        "BUTTONS": {
          "NEED_HELP": "Nepieciešama palīdzība?",
          "DISMISS": "Atcelt",
          "FINISH": "Pabeigt Iestatīšanu"
        },
        "DISMISS_MESSAGE": "OpenAI integrāciju varat iestatīt vēlāk, kad vien vēlaties.",
        "SUCCESS_MESSAGE": "OpenAI integrācija iestatīta veiksmīgi"
      },
      "TITLE": "Uzlabot ar AI",
      "SUMMARY_TITLE": "Kopsavilkums ar AI",
      "REPLY_TITLE": "Atbildes rekomendācija ar AI",
      "SUBTITLE": "Izmantojot AI, tiks ģenerēta uzlabota atbilde, pamatojoties uz jūsu pašreizējo melnrakstu.",
      "TONE": {
        "TITLE": "Tonis",
        "OPTIONS": {
          "PROFESSIONAL": "Profesionāls",
          "FRIENDLY": "Draudzīgs"
        }
      },
      "BUTTONS": {
        "GENERATE": "Ģenerēt",
        "GENERATING": "Notiek ģenerēšana...",
        "CANCEL": "Atcelt"
      },
      "GENERATE_ERROR": "Apstrādājot saturu radās kļūda. Lūdzu, pārbaudiet savu OpenAI API atslēgu un mēģiniet vēlreiz"
    },
    "DELETE": {
      "BUTTON_TEXT": "Dzēst",
      "API": {
        "SUCCESS_MESSAGE": "Integrācija ir veiksmīgi izdzēsta"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Savienot"
    },
    "DASHBOARD_APPS": {
      "TITLE": "Informācijas paneļa lietotnes",
      "HEADER_BTN_TXT": "Pievienot jaunu informācijas paneļa lietotni",
      "SIDEBAR_TXT": "<p><b>Informācijas Paneļa Lietotnes</b></p><p>Informācijas paneļa lietotnes ļauj organizācijām iegult lietojumprogrammu informācijas panelī, lai nodrošinātu kontekstu klientu atbalsta aģentiem. Šī funkcija ļauj Jums izveidot lietojumprogrammu neatkarīgi un iegult to informācijas panelī, lai sniegtu informāciju par lietotāju, viņu pasūtījumiem vai viņu iepriekšējo maksājumu vēsturi.</p><p>Kad iegulsiet lietojumprogrammu informācijas panelī, Jūsu lietojumprogramma iegūs sarunas un kontaktpersonas kontekstu kā loga notikumu. Ieviesiet savā lapā ziņojuma notikuma uztvērēju, lai saņemtu kontekstu.</p><p>Lai pievienotu jaunu informācijas paneļa lietotni, noklikšķiniet uz pogas 'Pievienot jaunu informācijas paneļa lietotni'.</p>",
      "DESCRIPTION": "Informācijas paneļa lietotnes ļauj organizācijām iegult lietojumprogrammu informācijas panelī, lai nodrošinātu kontekstu klientu atbalsta aģentiem. Šī funkcija ļauj Jums neatkarīgi izveidot lietojumprogrammu un iegult to, lai sniegtu informāciju par lietotāju, viņu pasūtījumiem vai iepriekšējo maksājumu vēsturi.",
      "LEARN_MORE": "Uzzināt vairāk par Informācijas paneļa Lietotnēm",
      "LIST": {
        "404": "Šajā kontā vēl nav nokonfigurēta neviena informācijas paneļa lietotne",
        "LOADING": "Notiek informācijas paneļa lietotņu iegūšana...",
        "TABLE_HEADER": {
          "NAME": "Nosaukums",
          "ENDPOINT": "Endpoint"
        },
        "EDIT_TOOLTIP": "Rediģēt lietotni",
        "DELETE_TOOLTIP": "Dzēst lietotni"
      },
      "FORM": {
        "TITLE_LABEL": "Nosaukums",
        "TITLE_PLACEHOLDER": "Ievadiet informācijas paneļa lietotnes nosaukumu",
        "TITLE_ERROR": "Informācijas paneļa lietotnei ir jānorāda nosaukums",
        "URL_LABEL": "Endpoint",
        "URL_PLACEHOLDER": "Ievadiet endpoint URL, kurā tiek mitināta jūsu lietotne",
        "URL_ERROR": "Nepieciešams derīgs URL"
      },
      "CREATE": {
        "HEADER": "Pievienot jaunu informācijas paneļa lietotni",
        "FORM_SUBMIT": "Iesniegt",
        "FORM_CANCEL": "Atcelt",
        "API_SUCCESS": "Informācijas paneļa lietotne ir veiksmīgi nokonfigurēta",
        "API_ERROR": "Mēs nevarējām izveidot lietotni. Lūdzu, vēlāk pamēģiniet vēlreiz"
      },
      "UPDATE": {
        "HEADER": "Rediģēt informācijas paneļa lietotni",
        "FORM_SUBMIT": "Atjaunināt",
        "FORM_CANCEL": "Atcelt",
        "API_SUCCESS": "Informācijas paneļa lietotne ir veiksmīgi atjaunināta",
        "API_ERROR": "Mēs nevarējām atjaunināt lietotni. Lūdzu, vēlāk pamēģiniet vēlreiz"
      },
      "DELETE": {
        "CONFIRM_YES": "Jā, dzēst",
        "CONFIRM_NO": "Nē, paturēt",
        "TITLE": "Apstipriniet dzēšanu",
        "MESSAGE": "Vai tiešām vēlaties izdzēst lietotni - {appName}?",
        "API_SUCCESS": "Informācijas paneļa lietotne ir veiksmīgi izdzēsta",
        "API_ERROR": "Mēs nevarējām izdzēst lietotni. Lūdzu, vēlāk pamēģiniet vēlreiz"
      }
    },
    "LINEAR": {
      "ADD_OR_LINK_BUTTON": "Izveidot/Saistīt lineāru problēmu",
      "LOADING": "Notiek lineāru problēmu iegūšana...",
      "LOADING_ERROR": "Lineāru problēmu iegūšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz",
      "CREATE": "Izveidot",
      "LINK": {
        "SEARCH": "Meklēt problēmas",
        "SELECT": "Izvēlieties problēmu",
        "TITLE": "Saite",
        "EMPTY_LIST": "Netika atrasta neviena lineāra problēma",
        "LOADING": "Notiek ielāde",
        "ERROR": "Lineāru problēmu iegūšanas laikā radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LINK_SUCCESS": "Problēma ir veiksmīgi sasaistīta",
        "LINK_ERROR": "Sasaistot problēmu radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LINK_TITLE": "Saruna (#{conversationId}) ar {name}"
      },
      "ADD_OR_LINK": {
        "TITLE": "Izveidot/saistīt lineāru problēmu",
        "DESCRIPTION": "Izveidot lineārus jautājumus no sarunām, vai saistīt esošos netraucētai izsekošanai.",
        "FORM": {
          "TITLE": {
            "LABEL": "Nosaukums",
            "PLACEHOLDER": "Ievadiet virsrakstu",
            "REQUIRED_ERROR": "Nepieciešams nosaukums"
          },
          "DESCRIPTION": {
            "LABEL": "Apraksts",
            "PLACEHOLDER": "Ievadiet aprakstu"
          },
          "TEAM": {
            "LABEL": "Komanda",
            "PLACEHOLDER": "Izvēlieties komandu",
            "SEARCH": "Meklēt komandu",
            "REQUIRED_ERROR": "Nepieciešama komanda"
          },
          "ASSIGNEE": {
            "LABEL": "Uzdevuma saņēmējs",
            "PLACEHOLDER": "Izvēlēties pilnvaroto",
            "SEARCH": "Meklēt pilnvaroto"
          },
          "PRIORITY": {
            "LABEL": "Prioritāte",
            "PLACEHOLDER": "Izvēlieties prioritāti",
            "SEARCH": "Meklēt prioritāti"
          },
          "LABEL": {
            "LABEL": "Etiķete",
            "PLACEHOLDER": "Izvēlēties etiķeti",
            "SEARCH": "Meklēt etiķeti"
          },
          "STATUS": {
            "LABEL": "Statuss",
            "PLACEHOLDER": "Izvēlēties statusu",
            "SEARCH": "Meklēt statusu"
          },
          "PROJECT": {
            "LABEL": "Projekts",
            "PLACEHOLDER": "Izvēlēties projektu",
            "SEARCH": "Meklēt projektu"
          }
        },
        "CREATE": "Izveidot",
        "CANCEL": "Atcelt",
        "CREATE_SUCCESS": "Problēma ir veiksmīgi izveidota",
        "CREATE_ERROR": "Veidojot problēmu radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LOADING_TEAM_ERROR": "Ienesot komandas radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "LOADING_TEAM_ENTITIES_ERROR": "Ienesot komandas entītijas radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "ISSUE": {
        "STATUS": "Statuss",
        "PRIORITY": "Prioritāte",
        "ASSIGNEE": "Uzdevuma saņēmējs",
        "LABELS": "Etiķetes",
        "CREATED_AT": "Izveidots {createdAt}"
      },
      "UNLINK": {
        "TITLE": "Atsaistīt",
        "SUCCESS": "Problēma ir veiksmīgi atsaistīta",
        "ERROR": "Atsaistot jautājumu radās kļūda. Lūdzu, mēģiniet vēlreiz"
      },
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties dzēst integrāciju?",
        "MESSAGE": "Vai tiešām vēlaties dzēst integrāciju?",
        "CONFIRM": "Jā, dzēst",
        "CANCEL": "Atcelt"
      }
    }
  },
  "CAPTAIN": {
    "NAME": "Kapteinis",
    "HEADER_KNOW_MORE": "Know more",
    "COPILOT": {
      "SEND_MESSAGE": "Sūtīt ziņojumu...",
      "EMPTY_MESSAGE": "Radās kļūda, ģenerējot atbildi. Lūdzu, mēģiniet vēlreiz.",
      "LOADER": "Kapteinis domā",
      "YOU": "Jūs",
      "USE": "Izmantot šo",
      "RESET": "Atiestatīt",
      "SELECT_ASSISTANT": "Izvēlēties Asistentu"
    },
    "PAYWALL": {
      "TITLE": "Modernizējiet abonementu, lai izmantotu Captain AI",
      "AVAILABLE_ON": "Captain nav pieejams bezmaksas abonementā.",
      "UPGRADE_PROMPT": "Modernizējiet savu abonementu, lai iegūtu piekļuvi viruālajiem asistentiem un copilot.",
      "UPGRADE_NOW": "Pāriet uz maksas versiju tagad",
      "CANCEL_ANYTIME": "Jūs varat jebkurā laikā mainīt vai atcelt savu versiju"
    },
    "ENTERPRISE_PAYWALL": {
      "AVAILABLE_ON": "Captain AI funkcija ir pieejama tikai maksas abonementā.",
      "UPGRADE_PROMPT": "Modernizējiet savu abonementu, lai iegūtu piekļuvi viruālajiem asistentiem un copilot.",
      "ASK_ADMIN": "Lai pārietu uz maksas versiju, lūdzu sazinieties ar savu administratoru."
    },
    "BANNER": {
      "RESPONSES": "Jūs esat izmantojis vairāk kā 80% no sava atbilžu ierobežojuma. Lai turpinātu izmantot Captain AI, lūdzu, atjauniniet abonementu.",
      "DOCUMENTS": "Sasniegts dokumentu limits. Atjauniniet abonementu, lai turpinātu izmantot Captain AI."
    },
    "FORM": {
      "CANCEL": "Atcelt",
      "CREATE": "Izveidot",
      "EDIT": "Atjaunināt"
    },
    "ASSISTANTS": {
      "HEADER": "Asistenti",
      "ADD_NEW": "Izveidot jaunu asistentu",
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties izdzēst asistentu?",
        "DESCRIPTION": "Šī darbība ir pastāvīga. Dzēšot šo asistentu, tas tiks noņemts no visām pievienotajām iesūtnēm un neatgriezeniski dzēstas visas ģenerētās zināšanas.",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Asistents ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Dzēšot asistentu radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM_DESCRIPTION": "Aizpildiet anketu, lai nosauktu savu asistentu, norādītu tā mērķi un produktu, ko tas atbalstīs.",
      "CREATE": {
        "TITLE": "Izveidot asistentu",
        "SUCCESS_MESSAGE": "Asistents ir veiksmīgi izveidots",
        "ERROR_MESSAGE": "Veidojot asistentu radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "NAME": {
          "LABEL": "Asistenta Vārds",
          "PLACEHOLDER": "Ievadiet asistenta vārdu",
          "ERROR": "Lūdzu, norādiet asistenta vārdu"
        },
        "DESCRIPTION": {
          "LABEL": "Asistenta Apraksts",
          "PLACEHOLDER": "Aprakstiet, kā un kur šis asistents tiks izmantots",
          "ERROR": "Nepieciešams apraksts"
        },
        "PRODUCT_NAME": {
          "LABEL": "Produkta Nosaukums",
          "PLACEHOLDER": "Ievadiet produkta nosaukumu, kam šis asistents ir paredzēts",
          "ERROR": "Nepieciešams produkta nosaukums"
        },
        "FEATURES": {
          "TITLE": "Īpašības",
          "ALLOW_CONVERSATION_FAQS": "Ģenerēt bieži uzdotos jautājumus no atrisinātajām sarunām",
          "ALLOW_MEMORIES": "Pārtvert galvenās nianses kā atmiņas no klientu mijiedarbībām."
        }
      },
      "EDIT": {
        "TITLE": "Atjaunināt asistentu",
        "SUCCESS_MESSAGE": "Asistents ir veiksmīgi atjaunināts",
        "ERROR_MESSAGE": "Atjauninot asistentu radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "OPTIONS": {
        "EDIT_ASSISTANT": "Rediģēt Asistentu",
        "DELETE_ASSISTANT": "Dzēst Asistentu",
        "VIEW_CONNECTED_INBOXES": "Skatīt pievienotās iesūtnes"
      },
      "EMPTY_STATE": {
        "TITLE": "Asistenti nav pieejami",
        "SUBTITLE": "Izveidot palīgu, lai sniegtu lietotājiem ātras un precīzas atbildes. Tas var mācīties no Jūsu palīdzības rakstiem un iepriekšējām sarunām.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Assistant",
          "NOTE": "Captain Assistant engages directly with customers, learns from your help docs and past conversations, and delivers instant, accurate responses. It handles the initial queries, providing quick resolutions before  transferring to an agent when needed."
        }
      }
    },
    "DOCUMENTS": {
      "HEADER": "Dokumenti",
      "ADD_NEW": "Izveidot jaunu dokumentu",
      "RELATED_RESPONSES": {
        "TITLE": "Saistītie bieži uzdotie jautājumi",
        "DESCRIPTION": "Šie bieži uzdotie jautājumi tiek ģenerēti tieši no dokumenta."
      },
      "FORM_DESCRIPTION": "Ievadiet dokumenta URL, lai to pievienotu kā zināšanu avotu, un izvēlieties asistentu, ar kuru to saistīt.",
      "CREATE": {
        "TITLE": "Pievienot dokumentu",
        "SUCCESS_MESSAGE": "Dokuments ir veiksmīgi izveidots",
        "ERROR_MESSAGE": "Veidojot dokumentu, radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "URL": {
          "LABEL": "URL",
          "PLACEHOLDER": "Ievadiet dokumenta URL",
          "ERROR": "Lūdzu, norādiet pareizu dokumenta URL"
        },
        "ASSISTANT": {
          "LABEL": "Asistents",
          "PLACEHOLDER": "Izvēlēties asistentu",
          "ERROR": "Asistenta lauks ir obligāti jāaizpilda"
        }
      },
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties izdzēst šo dokumentu?",
        "DESCRIPTION": "Šī darbība ir pastāvīga. Dzēšot šo dokumentu visas ģenerētās zināšanas tiks neatgriezeniski izdzēstas.",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Dokuments ir veiksmīgi izdzēsts",
        "ERROR_MESSAGE": "Dzēšot dokumentu radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "OPTIONS": {
        "VIEW_RELATED_RESPONSES": "Skatīt Saistītās Atbildes",
        "DELETE_DOCUMENT": "Dzēst Dokumentu"
      },
      "EMPTY_STATE": {
        "TITLE": "Dokumenti nav pieejami",
        "SUBTITLE": "Jūsu palīgs izmanto dokumentus, lai izveidotu bieži uzdotos jautājumus. Jūs varat importēt dokumentus, lai nodrošinātu kontekstu savam palīgam.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain Document",
          "NOTE": "A document in Captain serves as a knowledge resource for the assistant. By connecting your help center or guides, Captain can analyze the content and provide accurate responses for customer inquiries."
        }
      }
    },
    "RESPONSES": {
      "HEADER": "Bieži uzdotie jautājumi",
      "ADD_NEW": "Izveidot jaunu sarakstu ar bieži uzdotiem jautājumiem",
      "DOCUMENTABLE": {
        "CONVERSATION": "Saruna #{id}"
      },
      "SELECTED": "Atlasīti {count}",
      "BULK_APPROVE_BUTTON": "Apstiprināt",
      "BULK_DELETE_BUTTON": "Dzēst",
      "BULK_APPROVE": {
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi apstiprināti",
        "ERROR_MESSAGE": "Apstiprinot bieži uzdotos jautājumus radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "BULK_DELETE": {
        "TITLE": "Vai dzēst bieži uzdotos jautājumus?",
        "DESCRIPTION": "Vai tiešām vēlaties dzēst atlasītos bieži uzdotos jautājumus? Šo darbību nevar atsaukt.",
        "CONFIRM": "Jā, dzēst visu",
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi izdzēsti",
        "ERROR_MESSAGE": "Dzēšot bieži uzdotos jautājumus radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties izdzēst šos bieži uzdotos jautājumus?",
        "DESCRIPTION": "",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi izdzēsti",
        "ERROR_MESSAGE": "Dzēšot bieži uzdotos jautājumus radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FILTER": {
        "ASSISTANT": "Asistents: {selected}",
        "STATUS": "Statuss: {selected}",
        "ALL_ASSISTANTS": "Visi"
      },
      "STATUS": {
        "TITLE": "Statuss",
        "PENDING": "Gaida",
        "APPROVED": "Apstiprināts",
        "ALL": "Visi"
      },
      "FORM_DESCRIPTION": "Pievienot jautājumu un tā atbildi zināšanu bāzei, kā arī izvēlēties asistentu, ar kuru tas būs saistīts.",
      "CREATE": {
        "TITLE": "Pievienot bieži uzdotos jautājumus",
        "SUCCESS_MESSAGE": "Atbilde ir veiksmīgi pievienota.",
        "ERROR_MESSAGE": "Pievienojot atbildi radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "QUESTION": {
          "LABEL": "Jautājums",
          "PLACEHOLDER": "Ievadiet jautājumu šeit",
          "ERROR": "Lūdzu, ievadiet derīgu jautājumu."
        },
        "ANSWER": {
          "LABEL": "Atbilde",
          "PLACEHOLDER": "Ievadiet atbildi šeit",
          "ERROR": "Lūdzu, ievadiet derīgu atbildi."
        },
        "ASSISTANT": {
          "LABEL": "Asistents",
          "PLACEHOLDER": "Izvēlieties asistentu",
          "ERROR": "Lūdzu, izvēlieties asistentu."
        }
      },
      "EDIT": {
        "TITLE": "Atjaunināt bieži uzdotos jautājumus",
        "SUCCESS_MESSAGE": "Bieži uzdotie jautājumi ir veiksmīgi atjaunināti",
        "ERROR_MESSAGE": "Atjauninot bieži uzdotos jautājumus, radās kļūda. Lūdzu, mēģiniet vēlreiz",
        "APPROVE_SUCCESS_MESSAGE": "Bieži uzdotie jautājumi tika atzīmēti kā apstiprināti"
      },
      "OPTIONS": {
        "APPROVE": "Atzīmēt kā apstiprinātu",
        "EDIT_RESPONSE": "Rediģēt bieži uzdotos jautājumus",
        "DELETE_RESPONSE": "Dzēst bieži uzdotos jautājumus"
      },
      "EMPTY_STATE": {
        "TITLE": "Bieži uzdoto jautājumu saraksti nav atrasti",
        "SUBTITLE": "Bieži uzdotie jautājumi palīdz Jūsu asistentam sniegt ātras un precīzas atbildes uz Jūsu klientu jautājumiem. Tos var ģenerēt automātiski no jūsu satura vai pievienot manuāli.",
        "FEATURE_SPOTLIGHT": {
          "TITLE": "Captain FAQ",
          "NOTE": "Captain FAQs detects common customer questions—whether missing from your knowledge base or frequently asked—and generates relevant FAQs to improve support. You can review each suggestion and decide whether to approve or reject it."
        }
      }
    },
    "INBOXES": {
      "HEADER": "Pievienotās Iesūtnes",
      "ADD_NEW": "Pievienot jaunu iesūtni",
      "OPTIONS": {
        "DISCONNECT": "Atvienot"
      },
      "DELETE": {
        "TITLE": "Vai tiešām vēlaties atvienot iesūtni?",
        "DESCRIPTION": "",
        "CONFIRM": "Jā, dzēst",
        "SUCCESS_MESSAGE": "Iesūtne tika veiksmīgi atvienota.",
        "ERROR_MESSAGE": "Atvienojot iesūtni radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM_DESCRIPTION": "Izvēlieties iesūtni, lai izveidotu savienojumu ar asistentu.",
      "CREATE": {
        "TITLE": "Pievienot Iesūtni",
        "SUCCESS_MESSAGE": "Iesūtne tika veiksmīgi pievienota.",
        "ERROR_MESSAGE": "Pievienojot iesūtni radās kļūda. Lūdzu, mēģiniet vēlreiz."
      },
      "FORM": {
        "INBOX": {
          "LABEL": "Iesūtne",
          "PLACEHOLDER": "Izvēlieties iesūtni, lai aktivētu asistentu.",
          "ERROR": "Nepieciešams izvēlēties iesūtni."
        }
      },
      "EMPTY_STATE": {
        "TITLE": "Nav Pievienotu Iesūtņu",
        "SUBTITLE": "Iesūtnes pievienošana ļauj asistentam apstrādāt Jūsu klientu sākotnējos jautājumus, pirms tos pārsūtīt Jums."
      }
    }
  }
}
